import { render, staticRenderFns } from "./expect.vue?vue&type=template&id=5f2a8261&scoped=true&"
import script from "./expect.vue?vue&type=script&lang=js&"
export * from "./expect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a8261",
  null
  
)

export default component.exports